module.exports = __webpack_public_path__ + "img/Innoscience-icon.e14b4d43.png";